/**
 * True when the markup React is rendering over was produced by
 * scripts/prerender.js (see the data-prerendered flag it writes onto #root).
 *
 * That markup is already painted by the time the bundle boots, so components
 * above the fold use this to render straight into their final state instead of
 * replaying an entrance animation — otherwise content that is visibly on screen
 * would blink out and fade back in. Scroll-triggered animations further down the
 * page are unaffected.
 */
export const wasPrerendered =
  typeof document !== 'undefined' &&
  document.getElementById('root')?.dataset.prerendered === 'true';
